import AvisoModal from 'components/AvisoModal';
import PasswordInput from 'components/PasswordInput';
import SearchableSelect from 'components/SearchableSelect';
import styles from './UserFormModal.module.css';

const FIELD_MAX_LENGTH = { name: 150, last_name: 150 };

// `error`: validación o error del servidor al guardar; se muestra DENTRO del modal (la alerta de la página queda tapada por él).
export default function UserFormModal({ editing, form, set, save, close, error }) {
  return (
    <div className="modal-overlay" onClick={close}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{editing ? 'Editar' : 'Nuevo'} usuario</h3>
          <button className="btn-close" onClick={close}>✕</button>
        </div>
        <form onSubmit={save} noValidate>
          <div className="modal-body">
            {error && <AvisoModal>{error}</AvisoModal>}
            <div className={styles.rejilla}>
              <div className="form-group">
                <label className="form-label">Nombre *</label>
                <input type="text" className="form-control" value={form.name} onChange={e => set('name', e.target.value)} required maxLength={FIELD_MAX_LENGTH.name} />
              </div>
              <div className="form-group">
                <label className="form-label">Apellido</label>
                <input type="text" className="form-control" value={form.last_name} onChange={e => set('last_name', e.target.value)} maxLength={FIELD_MAX_LENGTH.last_name} />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Email *</label>
              <input type="email" className="form-control" value={form.email} onChange={e => set('email', e.target.value)} required />
            </div>
            <div className="form-group">
              <label className="form-label">Teléfono</label>
              <input type="text" className="form-control" value={form.phone} onChange={e => set('phone', e.target.value)} />
            </div>
            <div className="form-group">
              <label className="form-label">{editing ? 'Nueva contraseña (dejar vacío para no cambiar)' : 'Contraseña *'}</label>
              <PasswordInput value={form.password} onChange={e => set('password', e.target.value)} required={!editing} minLength={8} autoComplete="new-password" />
            </div>
            <div className="form-group">
              <label className="form-label">Rol *</label>
              <SearchableSelect value={form.role} onChange={(v) => set('role', v)} minWidth={0} maxWidth={9999} allowEmpty={false} ariaLabel="Rol" options={[{ value: 'user', label: 'Usuario' }, { value: 'admin', label: 'Administrador' }]} />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={close}>Cancelar</button>
            <button type="submit" className="btn btn-primary"><i className="fas fa-save" /> Guardar</button>
          </div>
        </form>
      </div>
    </div>
  );
}
